import { useState } from 'react';
import { Tab, Tabs } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { PageLoader } from '@app/components/PageLoader';
import TermsAndConditions from '@modules/borrower/components/TermsAndConditions';
import { useBorrowerData } from '@modules/borrower/hooks/useBorrowerData';
import LoanCalculator from '@modules/calculator/components/LoanCalculator';
import ActiveLoan from './loans/ActiveLoan';
import NoLoans from './loans/NoLoans';
import PastLoansTable from './pastLoansTable/PastLoansTable';
const Borrower = () => {
    var _a;
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('main');
    const { termsAndConditions, activeLoans, pastLoanApplications, functionalities, loadingPastLoans, isLoading } = useBorrowerData();
    if (isLoading) {
        return <PageLoader />;
    }
    const showTermsAndConditions = !(termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.accepted);
    const showCalculator = (_a = functionalities === null || functionalities === void 0 ? void 0 : functionalities.borrowing) === null || _a === void 0 ? void 0 : _a.enabled;
    return (<Tabs selectedKey={activeTab} onSelectionChange={(key) => setActiveTab(key)} variant="underline">
            {[
            showTermsAndConditions ? (<Tab key="main" label={t('financing.borrowing_page.getting_started')} tabKey="main">
                            <TermsAndConditions agreements={termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.agreements}/>
                        </Tab>) : (<Tab key="main" label={t('financing.borrowing_page.my_loans')} tabKey="main">
                            {activeTab === 'main' && (<>
                                    {activeLoans.length > 0 &&
                        activeLoans.map((loan) => (<div className="mb-4" key={loan.id}>
                                                <ActiveLoan loanApplication={loan}/>
                                            </div>))}
                                    {!activeLoans.length && <NoLoans />}

                                    {pastLoanApplications.length > 0 && (<div className="mt-8">
                                            <h2 className="mb-4 headline-s">
                                                {t('financing.borrowing_page.old_loans')}
                                            </h2>
                                            <PastLoansTable pastLoans={pastLoanApplications} loading={loadingPastLoans}/>
                                        </div>)}
                                </>)}
                        </Tab>),
            showCalculator ? (<Tab key="calculator" label={t('financing.borrowing_page.demo_calculator')} tabKey="calculator">
                            {activeTab === 'calculator' && (<div>
                                    <LoanCalculator isDemo/>
                                </div>)}
                        </Tab>) : null,
        ].filter(Boolean)}
        </Tabs>);
};
export default Borrower;
